// extracted by mini-css-extract-plugin
export var chevronIcon = "_6s-2";
export var teamName = "_6s-1";
export var teamSwitcherButton = "_6s-0";